import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { ListDTO, ListResponseAPI } from 'src/lib/queries';
import { WebhookEvent } from 'src/features/webhook-events/utils/types';

const RESOURCE = '/webhooks/webhook-events/';

type QueryFnType = typeof queryFn;

const queryFn = ({ ...params }: ListDTO): Promise<ListResponseAPI<WebhookEvent>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends ListDTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_WEBHOOK_EVENTS_RESOURCE, useQueryHook as useListWebhookEvents };
